// extracted by mini-css-extract-plugin
module.exports = {"root":"FormFieldset_root__zvzZ3","title":"FormFieldset_title__zr5f_","rotation":"FormFieldset_rotation__ftz8R"};